
import * as fileTypes from '../../constants/fileTypes';

export const getLinkTextFromServerText = (serverText: string): string => {
  const parts = serverText.split('target="_blank">')
  const lastPart = parts.pop()
  if (!lastPart) return ''

  const linkText = lastPart.split('</a>')[0]
  return linkText || ''
}

export const getNameFromLinkText = (linkText: string): string => {
  const fileName = linkText.replace(/\s\(\d+(\.\d+)?\s\w+\)$/i, '')
  return fileName || ''
}

export const addAttributeToUrls = (str: string, attribute: string) =>
  str.replace(/(http)([.]{0,}[^"]{0,})/gm, `$&${attribute}`);

export const getFileURL = (str: string): string => {
  const match = str.match(/href=\\?"([^"\\]+)\\?"/)
  return match ? match[1] : ''
}

export const getClassNameFromTag = (html: string): string => {
  const match = html.match(/class=(?:"|&quot;)(.*?)(?:"|&quot;)/i)
  return match ? match[1] : ''
}

export function getFilePreviewType(url: string): string {
  if (!url.match(/file-transfer\/download/gi)) return ''
  return getFileType(url)
}

export function getFileType(url: string): string {
  if (url.match(/\.png|\.jpg|\.jpeg|\.svg|\.gif|\.tiff/gi)) {
    return fileTypes.IMAGE
  }
  if (url.match(/\.mp3|\.wav|\.wav|\.aiff|\.ape|\.flac|\.ogg/gi)) {
    return fileTypes.AUDIO
  }
  if (url.match(/\.mp4|\.mov|\.avi|\.wmv|\.ogv|\.webm/gi)) {
    return fileTypes.VIDEO
  }

  return ''
}
